import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 账户相关
const topic = new Restful(project, 'topic')

topic.getArticle = (id, data) => {
  const url = project + `topic/${id}/article`
  return http.get(url, data).then(res => {
    return res
  })
}

topic.articleExp = (id, data) => {
  const url = project + `topic/${id}/article/export`
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

topic.getParticle = (topicId, data) => {
  const url = project + `topic/${topicId}/particle`
  return http.get(url, data).then(res => {
    return res
  })
}

topic.addParticle = (topicId, data) => {
  const url = project + `topic/${topicId}/particle`
  return http.post(url, data).then(res => {
    return res
  })
}

topic.particleExp = (topicId, data) => {
  const url = project + `topic/${topicId}/particle/export`
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

topic.updateParticle = (topicId, particleId, data) => {
  const url = project + `topic/${topicId}/particle/${particleId}`
  return http.put(url, data).then(res => {
    return res
  })
}

topic.queryParticle = (topicId, particleId, data) => {
  const url = project + `topic/${topicId}/particle/${particleId}`
  return http.get(url, data).then(res => {
    return res
  })
}

topic.delParticle = (topicId, particleId, data) => {
  const url = project + `topic/${topicId}/particle/${particleId}`
  return http.del(url, data).then(res => {
    return res
  })
}
topic.getAll = (id, data) => {
  const url = project + `topic/journal/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

export { topic }
